import { render } from "./Smartphone3.vue?vue&type=template&id=d983cec8&scoped=true"
import script from "./Smartphone3.vue?vue&type=script&lang=js"
export * from "./Smartphone3.vue?vue&type=script&lang=js"

import "./Smartphone3.vue?vue&type=style&index=0&id=d983cec8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d983cec8"

export default script